import { TypeExplorationModule } from "@contentful/types";
import { H1 } from "@yardzen/ui/components/h1";
import Image from "next/image";
import { PDFModal } from "./PDFModal";
export function ExploreYardzenDesign({
  explorationModule,
}: {
  explorationModule: TypeExplorationModule<"WITHOUT_UNRESOLVABLE_LINKS">;
}) {
  const {
    title,
    subtitle,
    id,
    image,
    mobileImage,
    buttons,
    sampleProject,
    modalCta,
  } = explorationModule.fields;

  return (
    <div id={id} className="bg-brand-beige-light">
      <div className="flex flex-col items-center justify-center px-1 py-12 max-md:pb-4 md:px-8">
        <div className="flex max-w-7xl flex-col items-center gap-28 md:flex-row">
          <div className="flex w-full flex-col px-8 md:max-w-[400px] md:px-0">
            <H1 className="!text-6xl">{title}</H1>
            <p className="text-brand-moss-greens-90 py-6 text-xl">{subtitle}</p>
            {buttons && sampleProject && modalCta && (
              <PDFModal
                key={buttons.sys.id}
                contentfulCTA={buttons}
                modalCta={modalCta}
                pdfContent={sampleProject}
              />
            )}
          </div>
          <div className="hidden max-h-[752px] max-w-[752px] sm:flex">
            {image && (
              <Image
                src={`https:${image?.fields.image?.fields.file?.url}`}
                alt={image?.fields.image?.fields.description ?? ""}
                width={752}
                height={752}
              />
            )}
          </div>
          <div className="flex max-h-[752px] max-w-[752px] sm:hidden">
            {mobileImage && (
              <Image
                src={`https:${mobileImage?.fields.image?.fields.file?.url}`}
                alt={mobileImage?.fields.image?.fields.description ?? ""}
                width={400}
                height={400}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
